var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"dense":"","no-gutters":""}},[_c('v-col',{attrs:{"offset":"0","cols":"12","sm":"12","md":"12","lg":"4","xl":"6"}},[_c('b',[_vm._v(_vm._s(_vm.label))])]),_c('v-col',{attrs:{"offset":"0","cols":"12","sm":"12","md":"12","lg":"8","xl":"6"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }